import kebabCase from 'lodash.kebabcase'

export const generateFallbackId = (children: React.ReactNode) =>
  typeof children === 'string' ? kebabCase(children) : undefined
